'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function Header() {
  const pathname = usePathname();

  return (
    <header className='relative flex w-full items-center justify-center overflow-hidden border-b'>
      <div className='z-10 flex w-full max-w-[1440px] items-center justify-between px-4 py-4'>
        <nav className='flex flex-1 items-center gap-2'>
          {navItems.map(item => {
            const isActive = item.href === pathname;

            return (
              <Link
                key={item.href}
                href={item.href}
                className={`flex transform items-center gap-1 rounded-lg px-6 py-3 font-medium transition-colors max-lg:justify-center max-sm:flex-1 ${
                  isActive
                    ? 'bg-[#D6F8D61A] text-[#D6F8D6]'
                    : 'text-[#EBEBEB99] hover:bg-[#EBEBEB1A] hover:text-[#EBEBEB]'
                }`}
              >
                {item.icon}
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

const navItems = [
  {
    href: '/',
    label: 'Perp',
    icon: (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.83335 16.6667V15H4.16669V5.00004H5.83335V3.33337H7.50002V5.00004H9.16669V15H7.50002V16.6667H5.83335ZM12.5 16.6667V12.5H10.8334V6.66671H12.5V3.33337H14.1667V6.66671H15.8334V12.5H14.1667V16.6667H12.5Z'
          fill='currentColor'
        />
      </svg>
    ),
  },
  {
    href: '/explorer/',
    label: 'Explorer',
    icon: (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M6.25002 13.75L12.0834 12.0833L13.75 6.24996L7.91669 7.91663L6.25002 13.75ZM10 11.25C9.6528 11.25 9.3578 11.1286 9.11502 10.8858C8.87224 10.643 8.75058 10.3477 8.75002 9.99996C8.74947 9.65218 8.87113 9.35718 9.11502 9.11496C9.35891 8.87274 9.65391 8.75107 10 8.74996C10.3461 8.74885 10.6414 8.87051 10.8859 9.11496C11.1303 9.3594 11.2517 9.6544 11.25 9.99996C11.2484 10.3455 11.127 10.6408 10.8859 10.8858C10.6447 11.1308 10.3495 11.2522 10 11.25ZM10 18.3333C8.84724 18.3333 7.76391 18.1144 6.75002 17.6766C5.73613 17.2388 4.85419 16.6452 4.10419 15.8958C3.35419 15.1463 2.76058 14.2644 2.32335 13.25C1.88613 12.2355 1.66724 11.1522 1.66669 9.99996C1.66613 8.84774 1.88502 7.7644 2.32335 6.74996C2.76169 5.73551 3.3553 4.85357 4.10419 4.10413C4.85308 3.35468 5.73502 2.76107 6.75002 2.32329C7.76502 1.88551 8.84835 1.66663 10 1.66663C11.1517 1.66663 12.235 1.88551 13.25 2.32329C14.265 2.76107 15.147 3.35468 15.8959 4.10413C16.6447 4.85357 17.2386 5.73551 17.6775 6.74996C18.1164 7.7644 18.335 8.84774 18.3334 9.99996C18.3317 11.1522 18.1128 12.2355 17.6767 13.25C17.2406 14.2644 16.647 15.1463 15.8959 15.8958C15.1447 16.6452 14.2628 17.2391 13.25 17.6775C12.2372 18.1158 11.1539 18.3344 10 18.3333Z'
          fill='currentColor'
          fill-opacity='0.6'
        />
      </svg>
    ),
  },
];
